import { defineStore } from 'pinia';
import MutationCall from '~/graphql/wrappers/mutation-call';

import  {
  AddTopicsToCoursesDocument,
  type AddTopicsToCoursesMutation,
  type AddTopicsToCoursesMutationVariables,
  TopicsDocument,
  UpdateTopicDocument,
  type UpdateTopicMutation,
  type UpdateTopicMutationVariables,
} from '~/graphql';

let updateTopicMutation: MutationCall<UpdateTopicMutation, UpdateTopicMutationVariables>;
let addTopicsToCoursesMutation: MutationCall<
  AddTopicsToCoursesMutation,
  AddTopicsToCoursesMutationVariables
>;

export const topicsCacheExchange = {
  updates: {
    Mutation: {
      removeTopic(result, _args, cache) {
        const topicId = _args.topicRemoveInput.id;
        cache.invalidate({ __typename: 'Topic', id: topicId });
      },
      reorderTopic(result, _args, cache) {
        const topicId = result.reorderTopic.topic.id;
        const position = _args.reorderTopicInput.position;
        cache.updateQuery(
          {
            query: TopicsDocument,
            variables: { topicFilterInput: { courseIds: [] } },
          },
          (data) => {
            if (data) {
              for (let i = 0; i < data.topics.length; i++) {
                if (data.topics[i]?.id === topicId) {
                  data.topics.splice(i, 1);
                }
              }
              data.topics.splice(position, 0, result.reorderTopic.topic);
            }
            return data;
          }
        );
      },
    },
  },
};

export const useTopicManagement = defineStore('topicManagement', () => {
  async function init() {
    updateTopicMutation = new MutationCall(UpdateTopicDocument);
    addTopicsToCoursesMutation = new MutationCall(AddTopicsToCoursesDocument);
  }

  async function updateTopic(topicId: string, updatedFields: object) {
    const result = await updateTopicMutation.run({
      updateTopicInput: {
        id: topicId,
        ...updatedFields,
      },
    });

    if (result.hasError()) {
      throw result.getError();
    }

    return result.getData().updateTopic.topic;
  }

  async function addTopicsToCoursesStoreMutation(
    topicIds: Array<string>,
    courseIds: Array<string>,
    fromLibrary?: boolean
  ) {
    const result = await addTopicsToCoursesMutation.run({
      addTopicCoursesInput: {
        topicIds,
        courseIds,
      },
    });

    if (result.hasError()) {
      throw result.getError();
    }

    return result.getData().addTopicsToCourses.done;
  }

  return {
    init,
    updateTopic,
    addTopicsToCoursesMutation: addTopicsToCoursesStoreMutation,
  };
});
